/* ============================================================
   Chillわんショップ — custom.js
   .cw-fade-up のスクロールイン演出（モックの IntersectionObserver を移植）。
   Craft 標準のセクション表示アニメで賄える場合はこのファイルは読み込み不要。
   prefers-reduced-motion の利用者には演出を出さず即表示する。
   ============================================================ */
(function () {
  'use strict';

  function revealAll() {
    document.querySelectorAll('.cw-fade-up').forEach(function (el) {
      el.classList.add('cw-visible');
    });
  }

  // モーション低減設定 or IO非対応なら即表示
  if (
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    revealAll();
    return;
  }
  if (!('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cw-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  function init() {
    document.querySelectorAll('.cw-fade-up').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // テーマエディタでセクション追加時にも再バインド
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.cw-fade-up').forEach(function (el) {
      observer.observe(el);
    });
  });
})();
